import { useTranslation } from 'react-i18next'

const HeaderItems = () => {
  const { t, ready } = useTranslation(['header'], { useSuspense: false })

  return {
    settingsMenuItems: [
      { name: `language`, label: ready && `${t('language')}` },
      { name: `currency`, label: ready && `${t('currency')}` },
      { name: `darkMode`, label: ready && `${t('darkMode')}` },
    ],
    comingSoonMenuItems: [{ name: `darkModeComingSoon`, label: '' }],

    loginMenuItems: userSessionExpired => {
      return [
        {
          name: userSessionExpired
            ? process.env.CGY_LOGIN
            : process.env.CGY_LOGOUT,
          label: userSessionExpired
            ? ready && `${t('login')}`
            : ready && `${t('logout')}`,
          isExternal: true,
        },
      ]
    },
    signupMenuItems: [
      {
        name: process.env.CGY_SIGNUP,
        label: ready && `${t('signup')}`,
        isExternal: true,
      },
    ],
    bakktMenuItem: [
      {
        name: 'https://app.coinigy.com/create-wallet',
        label: ready && `${t('createWallet')}`,
        isExternal: true,
      },
    ],

    menuItems: lang => [
      // {
      //   name: 'trade',
      //   label: `${t('trade')}`,
      //   items: [
      //     { name: `${lang}/trade/overview`, label: `${t('overview')}` },
      //     { name: `${lang}/trade/wallet`, label: `${t('wallet')}` },
      //     { name: `${lang}/trade/vip-program`, label: `${t('vip')}` },
      //   ],
      // },
      {
        name: 'explore',
        label: ready && `${t('explore')}`,
        items: [
          { name: `${lang}/exchanges`, label: ready && `${t('exchanges')}` },
          {
            name: `${lang}/cryptocurrencies`,
            label: ready && `${t('cryptocurrencies')}`,
          },
          { name: `${lang}/markets`, label: ready && `${t('markets')}` },
        ],
      },
      {
        name: 'the-platform',
        label: ready && `${t('platform')}`,
        items: [
          {
            name: `${lang}/platform/overview`,
            label: ready && `${t('overview')}`,
          },
          { name: `${lang}/platform/apps`, label: ready && `${t('apps')}` },
          { name: `${lang}/platform/api`, label: ready && `${t('api')}` },
          {
            name: `${lang}/platform/supported-exchanges`,
            label: ready && `${t('supportedExchs')}`,
          },
          {
            name: `${lang}/platform/pricing`,
            label: ready && `${t('pricing')}`,
          },
        ],
      },
      {
        name: 'resources',
        label: ready && `${t('resources')}`,
        items: [
          {
            name: 'https://insights.coinigy.com',
            label: ready && `${t('insights')}`,
            isExternal: true,
          },
          {
            name: 'https://support.coinigy.com',
            label: ready && `${t('support')}`,
            isExternal: true,
          },
          {
            name: 'https://www.coinigy.com/bitcoin-data/',
            label: ready && `${t('historicalData')}`,
            isExternal: true,
          },
          {
            name: 'https://support.coinigy.com/hc/en-us/community/topics',
            label: ready && `${t('community')}`,
            isExternal: true,
          },
        ],
      },
      {
        name: 'company',
        label: ready && `${t('company')}`,
        items: [
          { name: `${lang}/company/about`, label: ready && `${t('ourStory')}` },
          {
            name: `${lang}/company/testimonials`,
            label: ready && `${t('testimonials')}`,
          },
          {
            name: `${lang}/company/partnerships`,
            label: ready && `${t('partnerships')}`,
          },
          {
            name: `${lang}/company/referrals`,
            label: ready && `${t('referrals')}`,
          },
          { name: `${lang}/company/press`, label: ready && `${t('press')}` },
          {
            name: `${lang}/company/contact`,
            label: ready && `${t('contact')}`,
          },
          {
            name: 'https://shop.coinigy.com/',
            label: ready && `${t('bodega')}`,
            isExternal: true,
          },
          // {
          //   name: 'https://careers.coinigy.com',
          //   label: ready && `${t('careers')}`,
          //   isExternal: true,
          // },
        ],
      },
    ],

    topMenuItems: lang => [
      { name: `${lang}/exchanges`, label: ready && `${t('exchanges')}` },
      {
        name: `${lang}/cryptocurrencies`,
        label: ready && `${t('currencies')}`,
      },
      { name: `${lang}/markets`, label: ready && `${t('markets')}` },
    ],
  }
}

export default HeaderItems
